/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

// Scripts
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/page-header/page-header';

const selectors = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
};

function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
}

function checkUrlHash() {
    const hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
        toggleRecoverPasswordForm();
    }
}

/**
 *  Show/Hide recover password form
 */
function toggleRecoverPasswordForm() {
    const recoverPasswordForm = document.querySelector('#RecoverPasswordForm');
    const customerLoginForm = document.querySelector('#CustomerLoginForm');

    recoverPasswordForm.classList.toggle('hide');
    customerLoginForm.classList.toggle('hide');
}

/**
 *  Show reset password success message
 */
function resetPasswordSuccess() {
    const formState = document.querySelector('.reset-password-success');

    // check if reset password form was successfully submitted.
    if (!formState) {
        return;
    }

    // show success message
    const resetSuccess = document.querySelector('#ResetSuccess');
    resetSuccess.classList.remove('hide');
}

if (document.querySelector(selectors.recoverPasswordForm)) {
    checkUrlHash();
    resetPasswordSuccess();

    if (document.querySelector(selectors.recoverPasswordForm)) {
        document.querySelector(selectors.recoverPasswordForm).addEventListener('click', onShowHidePasswordForm);
    }

    if (document.querySelector(selectors.hideRecoverPasswordLink)) {
        document.querySelector(selectors.hideRecoverPasswordLink).addEventListener('click', onShowHidePasswordForm);
    }
}

const SIGN_IN_BUTTON    = '#login-submit';
const SIGN_UP_BUTTON    = '#form-register-submit';

document.addEventListener('DOMContentLoaded', function() {
    const signInButton = document.querySelector(SIGN_IN_BUTTON);
    const signUpButton = document.querySelector(SIGN_UP_BUTTON);

    if(signInButton) {
        signInButton.addEventListener('click', (event) => {
            dataLayer.push({'event': 'sign_in_attempt'});
        });
    }

    if(signUpButton) {
        signUpButton.addEventListener('click', (event) => {
            dataLayer.push({'event': 'sign_up_attempt'});
        });
    }
});
